import { render, staticRenderFns } from "./dashboard_altavenda.vue?vue&type=template&id=15df7c0c&scoped=true&"
import script from "./dashboard_altavenda.vue?vue&type=script&lang=js&"
export * from "./dashboard_altavenda.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_altavenda.vue?vue&type=style&index=0&id=15df7c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df7c0c",
  null
  
)

export default component.exports